import { baseApi } from "./baseApi";

const COMPLIANCE_BASE_URL = "/compliances"

export const complianceApi = baseApi.injectEndpoints({
    tagTypes: ["Compliance"],

    endpoints: (builder) => ({
        addCompliance: builder.mutation({
            query: (payLoad) => ({
                url: COMPLIANCE_BASE_URL,
                method: "POST",
                body: payLoad
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "Compliance", id: _id },
                { type: "Compliance", id: "LIST" },
            ],
        }),

        listCompliance: builder.query({
            query: (params) => ({
                url: COMPLIANCE_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Compliance", _id })),
                        { type: "Compliance", id: "LIST" },
                    ]
                    : [{ type: "Compliance", id: "LIST" }],
        }),

        getDDLComplianceList: builder.query({
            query: (params) => ({ url: `${COMPLIANCE_BASE_URL}/ddl`, params }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Compliance", _id })),
                        { type: "Compliance", id: "DDL" },
                    ]
                    : [{ type: "Compliance", id: "DDL" }],
        }),

        getComplianceDetail: builder.query({
            query: (Id) => `${COMPLIANCE_BASE_URL}/${Id}`,
            providesTags: (_result, _error, { _id }) => [
                { type: "Compliance", _id },
                { type: "Compliance", id: "LIST" },
            ],
        }),

        updateCompliance: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${COMPLIANCE_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "Compliance", id },
                { type: "Compliance", id: "LIST" },
            ],
        }),
    })

})

export const {
    useAddComplianceMutation,
    useListComplianceQuery,
    useLazyListComplianceQuery,
    useLazyGetDDLComplianceListQuery,
    useGetComplianceQuery,
    useGetComplianceDetailQuery,
    useUpdateComplianceMutation,
} = complianceApi;